<template>
  <div class="video-wrapper">
    <div class="video">
      <div
        class="wistia_responsive_padding"
        style="padding:56.25% 0 0 0;position:relative;"
      >
        <div
          class="wistia_responsive_wrapper"
          style="height:100%;left:0;position:absolute;top:0;width:100%;"
        >
          <div
          class="wistia_embed wistia_async_naz6vuy8ba videoFoam=true"
          style="height:100%;position:relative;width:100%"
          >
            <div
              class="wistia_swatch"
              style="height:100%;left:0;opacity:0;overflow:hidden;
              position:absolute;top:0;transition:opacity 200ms;width:100%;"
            >
              <img
                src="https://fast.wistia.com/embed/medias/naz6vuy8ba/swatch"
                style="filter:blur(5px);height:100%;object-fit:contain;width:100%;"
                alt=""
                onload="this.parentNode.style.opacity=1;"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="button" @click="$router.push('/')">Conoce más <img src="/right-arrow.svg" alt="Logo flagship"></div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
.video-wrapper {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  padding-top: 70px;
}
.video {
  width: 900px;
}
.button {
  font-family: 'Roboto Condensed', sans-serif;
  background-color: #2c70c1;;
  color: white;
  padding: 14px 0 14px 24px;
  width: 180px;
  display: flex;
  font-weight: bolder;
  font-size: 15px;
  text-transform: uppercase;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  img {
    height: 24px;
    width: auto;
    margin-right: 20px;
  }
}
@media only screen and (max-width: 900px) {
  .video {
    width: 94%;
  }
}
</style>

